import { type Registry as Services, service } from '@ember/service';
import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import type {
  Currency,
  CurrencyConversionExchangeRatesProfile,
} from 'lumen/models';
import dirtyRelationship, {
  type DirtyRelationshipModel,
} from 'lumen/utils/decorators/dirty-relationship';

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
interface CurrencyConversionExchangeRateModel
  extends DirtyRelationshipModel, Model {}

export const EXCHANGE_RATE_VALUE_MAX_DIGITS = 10;

@dirtyRelationship()
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class CurrencyConversionExchangeRateModel extends Model {
  [Type] = 'currency-conversion/exchange-rate' as const;
  @belongsTo('currency-conversion/exchange-rates-profile', {
    async: false,
    inverse: 'exchangeRates',
  })
  declare exchangeRatesProfile: CurrencyConversionExchangeRatesProfile;
  @attr('string') declare currencyCode: string;
  @attr('dayjs') declare endDate: DayjsTransformReturn;
  @attr('dayjs') declare startDate: DayjsTransformReturn;
  @attr('number') declare value: number | null;

  @service declare store: Services['store'];

  get currency(): Currency | null {
    return this.store.peekRecord<Currency>('currency', this.currencyCode);
  }

  get isValid(): boolean {
    if (this.value === null || this.value <= 0) {
      return false;
    }
    return this.value < 10 ** EXCHANGE_RATE_VALUE_MAX_DIGITS;
  }
}

export default CurrencyConversionExchangeRateModel;
